/**
 * Vuetify theme configuration using centralized theme values
 */
import { theme } from './index';

export const vuetifyTheme = {
  defaultTheme: 'light',
  themes: {
    light: {
      colors: {
        primary: theme.colors.primary,
        secondary: theme.colors.secondary,
        accent: theme.colors.accent,
        error: theme.colors.danger,
        warning: theme.colors.warning,
        info: theme.colors.info,
        success: theme.colors.success,
      },
    },
  },
};
